const createCaregiverAccessError = (code: string, message: string) => ({
  code,
  message,
  caregiverAccessError: true,
});

export const ensureCaregiverResidentOperationalAccess = async (
  backendAPIStore: any,
  residentId: string,
  _featureFlag?: string,
  _disabledMessage?: string,
) => {
  const normalizedResidentId = String(residentId || "").trim();
  if (!normalizedResidentId) {
    throw createCaregiverAccessError("INVALID_REQUEST", "residentId is required.");
  }

  await backendAPIStore.init();
  const residentAccess = await backendAPIStore.getCaregiverResidents(normalizedResidentId);
  if (!residentAccess) {
    throw createCaregiverAccessError("NOT_SHARED", "Resident is not shared with this caregiver.");
  }

  if (residentAccess?.providerSubscriptionActive === false) {
    throw createCaregiverAccessError(
      "SUBSCRIPTION_REQUIRED",
      String(residentAccess?.accessReason || "").trim() || "This resident is unavailable because the provider subscription is inactive.",
    );
  }

  if (residentAccess?.accessActive === false) {
    throw createCaregiverAccessError(
      "ACCESS_INACTIVE",
      String(residentAccess?.accessReason || "").trim() || "Resident access is not available right now.",
    );
  }

  return residentAccess;
};
